import {
  AspectRatio,
  Box,
  Button,
  Heading,
  HStack,
  Icon,
  Text,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { CONTACT_INFO } from "../../data/contact";
import { PiMapPinDuotone } from "react-icons/pi";
import { FiArrowLeft } from "react-icons/fi";

const MotionBox = motion(Box);

export const ContactMap = () => {
  const openMap = () => {
    window.open(CONTACT_INFO.mapHref, "_blank", "noopener,noreferrer");
  };

  return (
    <MotionBox
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 } as any}
    >
      <Box position="relative">
        <AspectRatio ratio={{ base: 1 / 1, md: 21 / 8 }} minH={{ md: "520px" }}>
          <iframe
            title="نقشه دفتر مرکزی تأمین سرمایه امید"
            src={CONTACT_INFO.mapEmbedSrc}
            style={{
              border: 0,
              width: "100%",
              height: "100%",
            }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </AspectRatio>

        <Box
          as={motion.div}
          position="absolute"
          insetX={{ base: 4, md: 12, lg: 24 }}
          bottom={{ base: 4, md: 8 }}
          bg={"rgba(15,19,28,0.9)"}
          backdropFilter="blur(18px)"
          borderRadius="2xl"
          p={6}
          boxShadow="2xl"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45, delay: 0.15 } as any}
        >
          <Heading color={"white"} size="md" mb={3}>
            آدرس دفتر مرکزی
          </Heading>
          <HStack align="center" mb={6} spacing={1}>
            <Icon as={PiMapPinDuotone as any} boxSize={6} color="red" />
            <Text
              color={"white"}
              lineHeight="tall"
              fontSize={{ base: "sm", md: "md" }}
            >
              {CONTACT_INFO.officeAddress}
            </Text>
          </HStack>
          <Button
            colorScheme="brand"
            rightIcon={<Icon verticalAlign="middle" as={FiArrowLeft as any} />}
            variant={"outline"}
            color="white"
            _hover={{ bg: "brand.600", borderColor: "brand.600" }}
            onClick={openMap}
          >
            نمایش روی نقشه
          </Button>
        </Box>
      </Box>
    </MotionBox>
  );
};
